import { Chip } from "@mui/material";

interface LiveChangesPillProps {
  count: number;
  onRefresh: () => void;
}

export default function LiveChangesPill({
  count,
  onRefresh,
}: LiveChangesPillProps) {
  if (!count) return null;
  return (
    <Chip
      color="primary"
      size="small"
      label={`${count} ${count === 1 ? "change" : "changes"} · Refresh`}
      onClick={onRefresh}
    />
  );
}
